module.exports = __webpack_public_path__ + "img/nav-girl-3.ba1d4db1.png";